import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { Container } from '../../layout/Container'
import { Check } from 'lucide-react'
import { useScrollAnimation } from '../../../hooks/useScrollAnimation'

interface InstalledItem {
  id: string
  title: string
  description: string
}

export function HowWeWorkInstalled() {
  const { t } = useTranslation()
  const { ref, isInView } = useScrollAnimation()

  const items = t('howWeWorkPage.installed.items', { returnObjects: true }) as InstalledItem[]

  return (
    <section ref={ref} className="border-y border-border bg-surface py-24">
      <Container size="wide">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-center">
          <motion.div
            initial={{ opacity: 0, x: -24 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.5 }}
          >
            <span className="text-sm font-medium uppercase tracking-wider text-accent-light">
              {t('howWeWorkPage.installed.label')}
            </span>
            <h2 className="mt-4 text-3xl font-semibold tracking-tight text-text-primary sm:text-4xl">
              {t('howWeWorkPage.installed.title')}
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-text-secondary">
              {t('howWeWorkPage.installed.description')}
            </p>
          </motion.div>

          <div className="space-y-6">
            {items.map((item, index) => (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, x: 24 }}
                animate={isInView ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                className="flex gap-4"
              >
                <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-accent/10 text-accent-light">
                  <Check className="h-4 w-4" />
                </div>
                <div>
                  <h3 className="text-lg font-medium text-text-primary">{item.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-text-secondary">{item.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  )
}
